function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { withRouter } from "react-router";
import { DetailContainer } from "../../components/container-activity";
import { BaseDataViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { MDCTextInput, MDCFileUpload } from '../../../jsx/components/mdc-components';
import { AlertMessage } from '../../ui/alert';
import ProgressSuccess from '../../ui/progress/success';
import endpoints from "../../endpoints";
import account from "../../data/account";
import Auth from "../../functions/authenticate";
import Locations from "./locations";
import ServiceFactory from "../../service";
import DatePicker from "react-datepicker";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "initServices", () => {
      var Service = ServiceFactory.getType('/market-trends', 'research');
      this.Service = new Service();
    });
    _defineProperty(this, "onTermChange", event => {
      var target = event.target;
      var value = target.value;
      this.setState({
        term: value
      });
    });
    _defineProperty(this, "onFromChange", value => {
      this.setState({
        fromDate: value
      });
    });
    _defineProperty(this, "onToChange", value => {
      this.setState({
        toDate: value
      });
    });
    _defineProperty(this, "onGoBack", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onFocus", event => {
      this.setState({
        showMessage: false,
        messageType: '',
        message: null
      });
    });
    _defineProperty(this, "onViewClick", () => {
      this.props.history.goBack();
    });
    _defineProperty(this, "onCreate", event => {
      let state = this.state;
      let message = null;
      let messageType = null;
      let showMessage = false;
      if (!state.term) {
        showMessage = true;
        messageType = 'error';
        message = 'Term Required...';
      }
      if (!state.fromDate) {
        showMessage = true;
        messageType = 'error';
        message = 'From Date Required...';
      }
      if (!state.toDate) {
        showMessage = true;
        messageType = 'error';
        message = 'To Date Required...';
      }
      if (showMessage) {
        this.setState({
          showMessage,
          messageType,
          message
        });
      } else {
        this.post();
      }
    });
    _defineProperty(this, "post", () => {
      let state = this.state;
      let model = {
        term: state.term,
        toDate: state.toDate,
        fromDate: state.fromDate,
        location: state.location,
        languageCode: state.languageCode,
        categoryCode: state.categoryCode,
        userId: state.userId
      };
      let message = null;
      let messageType = null;
      let showMessage = false;
      let showSuccess = true;
      this.Service.post(model, (err, data) => {
        if (!err) {
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess
          });
        } else {
          showSuccess = false;
          messageType = 'error';
          showMessage = true;
          message = 'Error submitting market trend...';
          this.setState({
            showMessage,
            messageType,
            message,
            showSuccess
          });
        }
      });
    });
    this.state = this.initState();
  }
  initState() {
    var auth = Auth.get();
    var email = auth.email;
    return {
      term: '',
      location: 'United States',
      categoryCode: 0,
      languageCode: 'en',
      fromDate: null,
      toDate: null,
      showSuccess: false,
      showMessage: false,
      messageType: '',
      message: null,
      userId: email
    };
  }
  componentDidMount() {
    this.initServices();
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    let state = this.state;
    return /*#__PURE__*/React.createElement(DetailContainer, {
      title: "New Market Trend",
      onGoBack: this.onGoBack
    }, state.showSuccess ? /*#__PURE__*/React.createElement(ProgressSuccess, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "medium size-14"
    }, "Your market trend has been successfully submitted.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
      className: "size-14"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: this.onViewClick
    }, "VIEW TRENDS GRID")))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("link", {
      href: "/css/react-datepicker.css",
      rel: "stylesheet"
    }), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "1. Term"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(MDCTextInput, {
      label: "Term",
      value: state.term,
      onChange: this.onTermChange,
      onFocus: this.onFocus
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "2. From Date"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      selected: state.fromDate,
      onChange: this.onFromChange //only when value has changed
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "medium"
    }, "3. To Date"), /*#__PURE__*/React.createElement("div", {
      className: "form-width"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      selected: state.toDate,
      onChange: this.onToChange //only when value has changed
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onCreate
    }, "Submit")), this.state.showMessage && /*#__PURE__*/React.createElement(AlertMessage, {
      message: state.message,
      cls: state.messageType
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null));
  }
}
export class MarketTrendsCreateViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  MarketTrendsCreateViewComponent
};